import React from "react";
import "../styles/banner.scss";

// Import banner images
import Banner1 from "../assets/banner/banner1.webp";
import Banner2 from "../assets/banner/banner2.webp";
import Banner3 from "../assets/banner/banner3.webp";
import Banner4 from "../assets/banner/banner4.webp";
import Banner5 from "../assets/banner/banner5.webp";

export default function BannerSection() {
  return (
    <section className="banner__section section--padding">
      <div className="container-fluid">
        <div className="row gy-4">
          
          {/* Banner 1 */}
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="banner__items">
              <a className="banner__items--thumbnail position__relative" href="/">
                <img
                  className="banner__items--thumbnail__img"
                  src={Banner1}
                  alt="White Minimalist Combo Sofa"
                />
                <div className="banner__items--content banner1__content">
                  <h2 className="banner__items--content__title banner1__title">
                    White Minimalist <br /> Combo Sofa
                  </h2>
                </div>
              </a>
            </div>
          </div>

          {/* Banner 2 */}
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="banner__items">
              <a className="banner__items--thumbnail position__relative" href="/">
                <img
                  className="banner__items--thumbnail__img"
                  src={Banner2}
                  alt="Modern Stylish Single Sofa"
                />
                <div className="banner__items--content banner2__content">
                  <h2 className="banner__items--content__title banner2__title">
                    Modern Stylish <br /> Single Sofa
                  </h2>
                </div>
              </a>
            </div>
          </div>

          {/* Banner 3 */}
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="banner__items">
              <a className="banner__items--thumbnail position__relative" href="/">
                <img
                  className="banner__items--thumbnail__img"
                  src={Banner3}
                  alt="Larger Minimal Wooden Chair"
                />
                <div className="banner__items--content banner3__content">
                  <h2 className="banner__items--content__title banner3__title">
                    Larger Minimal <br /> Wooden Chair
                  </h2>
                </div>
              </a>
            </div>
          </div>

          {/* Banner 4 + 5 (stacked) */}
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* Banner 4 */}
            <div className="banner__items mb-4">
              <a className="banner__items--thumbnail position__relative" href="/">
                <img
                  className="banner__items--thumbnail__img"
                  src={Banner4}
                  alt="Family Package Sofa Set"
                />
                <div className="banner__items--content banner4__content">
                  <h2 className="banner__items--content__title banner4__title">
                    Family Package <br /> Sofa Set
                  </h2>
                </div>
              </a>
            </div>

            {/* Banner 5 */}
            <div className="banner__items">
              <a className="banner__items--thumbnail position__relative" href="/">
                <img
                  className="banner__items--thumbnail__img"
                  src={Banner5}
                  alt="White Minimalist Combo Sofa"
                />
                <div className="banner__items--content banner5__content">
                  <h2 className="banner__items--content__title banner5__title">
                    White Minimalist <br /> Combo Sofa
                  </h2>
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
